import { combineReducers } from 'redux';
import { ActionType } from './newsCategory5Actions';

const loading = (state = false, { type }) => {
  switch (type) {
    case ActionType.NEWS_CATEGORY_5_REQUEST:
      return true;

    case ActionType.NEWS_CATEGORY_5_SUCCESS_UK:
    case ActionType.NEWS_CATEGORY_5_SUCCESS_RU:
    case ActionType.NEWS_CATEGORY_5_ERROR_UK:
    case ActionType.NEWS_CATEGORY_5_ERROR_RU:
      return false;

    default:
      return state;
  }
};

const newsCategory5UK = (state = [], { type, payload }) => {
  switch (type) {
    case ActionType.NEWS_CATEGORY_5_SUCCESS_UK:
      return state.concat(payload);

    default:
      return state;
  }
};

const newsCategory5RU = (state = [], { type, payload }) => {
  switch (type) {
    case ActionType.NEWS_CATEGORY_5_SUCCESS_RU:
      return state.concat(payload);

    default:
      return state;
  }
};

const newsCategory5ErrorUK = (state = null, { type, payload }) => {
  switch (type) {
    case ActionType.NEWS_CATEGORY_5_ERROR_UK:
      return payload;

    case ActionType.NEWS_CATEGORY_5_REQUEST:
    case ActionType.NEWS_CATEGORY_5_SUCCESS_UK:
      return null;

    default:
      return state;
  }
};

const newsCategory5ErrorRU = (state = null, { type, payload }) => {
  switch (type) {
    case ActionType.NEWS_CATEGORY_5_ERROR_RU:
      return payload;

    case ActionType.NEWS_CATEGORY_5_REQUEST:
    case ActionType.NEWS_CATEGORY_5_SUCCESS_RU:
      return null;

    default:
      return state;
  }
};

const newsCategory5PageNumberUK = (state = 1, { type }) => {
  switch (type) {
    case ActionType.NEWS_CATEGORY_5_PAGE_NUMBER_UK:
      return state + 1;

    default:
      return state;
  }
};

const newsCategory5PageNumberRU = (state = 1, { type }) => {
  switch (type) {
    case ActionType.NEWS_CATEGORY_5_PAGE_NUMBER_RU:
      return state + 1;

    default:
      return state;
  }
};

export default combineReducers({
  loading,
  newsCategory5UK,
  newsCategory5RU,
  newsCategory5ErrorUK,
  newsCategory5ErrorRU,
  newsCategory5PageNumberUK,
  newsCategory5PageNumberRU,
});
